import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import auth from "../services/authService";
import config from "../config.json";
import Pagination from "../comman/pagination";
import { paginate, calculateIndex } from "../utlis/paginate";
import PartnerPerformerTable from "./PartnerPerformerTable";
import PageSizeOptions from "./PageSizeOptions";
import ActiveDeactiveHistory from "./SystemAdministration/ManagePartner/ActiveDeactiveHistory";
import { getLoggedUser, getLoggedUserDetails, getCurrentUser } from "../app/store/auth";
import {
  getSubcontractorPerformers, loadSubcontractorPerformers,
  AddSubcontractorPerformer, getAddedSubPerformerStatus,
  loadSubcontractorBprmForm,
  getSubcontractorBprmForm,
  loadSubcontractorsByFilter,
  getFilterAllSubcontractors
} from "../app/store/subcontractor";
import {
  getRecruiterPerformers, loadRecruiterPerformers,
  AddRecruiterPerformer, getAddedRecPerfromerStatus,
  loadRecruiterBprmForm,
  getRecruiterBprmForm,
  getReminderStatus,
  loadRecruiters,
  getFilterAllRecruiters,
  reminderSent
} from "../app/store/recruiter";
import { setCurrentPageTitle, setCurrentRoute } from "../app/store/layoutUI";
import { getFormatedNumber } from "../services/appService";
import Moment from "react-moment";
import { SendReminder } from "../app/store/recruiter";
import { Tab, Tabs } from "react-bootstrap";
import WorkflowElement from "../app/components/WorkflowElement";
import { getAlert } from "../services/appAlerts";
import AddPartnerPerformer from "./AddPartnerPerformer";

export default function ManagePartnerPerformer(props) {

  const routeArray = [
    { name: "System Administration", url: "" },
    { name: "Manage Entities", url: "" },
  ];
  //const [route,setRoute]=useState(routeArray)
  const [partnerType, setPartnerType] = useState("Recruiter")
  const [performers, setPerformers] = useState([]);
  const [filterData, setFilterData] = useState([]);

  const [rowsCount, setRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(5);

  const [showHide, setShowHide] = useState(false);
  const [logShowHide, setLogShowHide] = useState(false);
  const [remainderMsgShowHide, setRemainderMsgShowHide] = useState(false);

  const [selectedObj, setSelectedObj] = useState(null);
  const [currentUser, setCurrentUser] = useState("");
  const [loggedUser, setLoggedUser] = useState("");

  const [performerId, setPerformerId] = useState("");
  const [performerName, setPerformerName] = useState("");
  const [mobile, setMobile] = useState("");

  const [actionType, setActionType] = useState("action");
  const [selectedUserId, setSelectedUserId] = useState(0);
  const [selectedKey, setSelectedKey] = useState("home");
  const [updatedStateData, setUpdatedStateData] = useState(null);
  const [viewFormType, setViewFormType] = useState("");
  const [wfTask, setWfTask] = useState(null);
  const [wfForm, setWfForm] = useState(null);
  const [performerdata, setPerformerdata] = useState({});
  const [dataType, setDataType] = useState("");
  const [isFiltering, setIsFiltering] = useState(false);

  const subcontractorPerformers = useSelector(getSubcontractorPerformers);
  const recruiterPerformers = useSelector(getRecruiterPerformers);

  const subPerformerAdded = useSelector(getAddedSubPerformerStatus);
  const recPerformerAdded = useSelector(getAddedRecPerfromerStatus);

  const subcontractorBprmFormSelector = useSelector(getSubcontractorBprmForm);
  const recruiterBprmFormSelector = useSelector(getRecruiterBprmForm)
  const filterAllRecruiters = useSelector(getFilterAllRecruiters);
  const filterAllSubcontractors = useSelector(getFilterAllSubcontractors);

  const userDetails = useSelector(getLoggedUserDetails);
  const remiderStatus = useSelector(getReminderStatus);

  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (subcontractorBprmFormSelector) setWfForm(subcontractorBprmFormSelector);
  }, [subcontractorBprmFormSelector])

  useEffect(() => {
    if (recruiterBprmFormSelector) setWfForm(recruiterBprmFormSelector);
  }, [recruiterBprmFormSelector])

  useEffect(() => {
    const state = location?.state;
    if (state?.partner && state?.url) {
      routeArray.push({ name: state.partner, url: state.url });
    }
    dispatch(setCurrentRoute(routeArray));
    dispatch(setCurrentPageTitle("Manage Users"))
  }, [])


  useEffect(() => {
    const state = location?.state;
    var frmBody = new FormData();
    frmBody.append("name", "");
    frmBody.append("email", "");
    if (state?.obj) {
      const currentObj = state.obj;
      setCurrentUser(currentObj);
      if (currentObj?.partnerType === "Sub-Contractors") {
        setPartnerType("Subcontractor");
        if (currentObj?.fuid) {
          dispatch(loadSubcontractorPerformers(currentObj.fuid));
        }
        frmBody.append("id", currentObj?.fuid || "");
        frmBody.append("type", "Sub-Contractors");
        dispatch(loadSubcontractorsByFilter(frmBody));
      }
      else {
        if (currentObj?.fuid) {
          dispatch(loadRecruiterPerformers(currentObj.fuid));
        }
        frmBody.append("id", currentObj?.fuid || "");
        frmBody.append("type", "Recruiter");
        dispatch(loadSubcontractorsByFilter(frmBody));
      }
    }
  }, []);

  useEffect(() => {
    setPerformerdata(filterAllRecruiters[0])
  }, [filterAllRecruiters])

  useEffect(() => {
    setPerformerdata(filterAllSubcontractors[0])
  }, [filterAllSubcontractors])

  useEffect(() => {
    getPagedData(subcontractorPerformers, currentPage, pageSize);
  }, [subcontractorPerformers]);

  useEffect(() => {
    getPagedData(recruiterPerformers, currentPage, pageSize);
  }, [recruiterPerformers]);

  useEffect(() => {
    const user = getCurrentUser();
    if (user?.type === "admin" && userDetails !== null) {
      const usrDetails = { ...userDetails, roleType: "admin" };
      setLoggedUser(usrDetails);
    }
  }, [userDetails]);

  useEffect(() => {
    if (subPerformerAdded && currentUser?.fuid) {
      dispatch(loadSubcontractorPerformers(currentUser.fuid));
    }
  }, [subPerformerAdded])

  useEffect(() => {
    if (recPerformerAdded && currentUser?.fuid) {
      dispatch(loadRecruiterPerformers(currentUser.fuid));
    }
  }, [recPerformerAdded])


  const handleSelection = (item) => {
    if (selectedUserId === item.id) {
      handleResetSelection();
      return;
    }
    const obj = performers.filter(x => x.id === item.id);
    if (obj.length > 0) {
      setSelectedObj(obj[0]);
      setSelectedUserId(item.id);
    }
  };


  const handleFormSubmit = (performer) => {
    if (currentUser?.fuid > 0) {
      performer["partnerId"] = currentUser.fuid;
      if (partnerType === "Subcontractor")
        dispatch(AddSubcontractorPerformer(performer));
      else
        dispatch(AddRecruiterPerformer(performer));
      setShowHide(!showHide);
    }
  };

  const getPagedData = (list, currentPage, pageSize) => {
    const items = paginate(list, currentPage, pageSize);
    setRowsCount(list.length);
    setPerformers(items);
  };

  const handleLogShowHide = (item, actionType) => {
    if (item === "save") {
      setLogShowHide(false);
      setSelectedObj("");
      setActionType(actionType);
      if (partnerType === "Subcontractor") {
        if (currentUser?.fuid) {
          dispatch(loadSubcontractorPerformers(currentUser.fuid));
        }
      } else {
        if (currentUser?.fuid) {
          dispatch(loadRecruiterPerformers(currentUser.fuid));
        }
      }
    } else {
      setLogShowHide(!logShowHide);
      setSelectedObj(item);
      setActionType(actionType);
    }
  };

  const handleTabSelect = (tab) => {
    setSelectedKey(tab);
  }

  const getSourcePerformers = () =>
    partnerType === "Subcontractor" ? subcontractorPerformers : recruiterPerformers;

  const handleFilter = async () => {
    setIsFiltering(true);
    let filtered =
      performerId !== ""
        ? getSourcePerformers().filter((p) => p.id === parseInt(performerId))
        : getSourcePerformers();

    filtered =
      performerName !== ""
        ? filtered.filter((x) =>
          x.name?.toLowerCase().includes(performerName.toLowerCase())
        )
        : filtered;

    filtered =
      mobile !== ""
        ? filtered.filter((x) => x.contact && x.contact.includes(mobile))
        : filtered;

    getPagedData(filtered, 1, pageSize)
    setDataType("filter");
    setTimeout(() => {
      setIsFiltering(false);
    }, 600);
  };

  const handleFilterCancel = () => {
    getPagedData(getSourcePerformers(), 1, pageSize);

    setPerformerId("");
    setPerformerName("");
    setMobile("");
    setDataType("");
    setIsFiltering(false);
  };

  const formatPhoneNumber = (value) => {
    if (!value) return value;
    const n = value.replace(/[^\d]/g, "");
    if (n.length < 4) return n;
    if (n.length < 7) return `${n.slice(0, 3)}-${n.slice(3)}`;
    return `${n.slice(0, 3)}-${n.slice(3, 6)}-${n.slice(6, 10)}`;
  };

  const getDisplayName = (performer) =>
    [performer?.name, performer?.lastName].filter(Boolean).join(" ").trim() || "Unnamed User";

  const getInitials = (performer) => {
    const nameParts = getDisplayName(performer).split(" ").filter(Boolean);
    return nameParts.slice(0, 2).map((part) => part.charAt(0).toUpperCase()).join("");
  };


  const handlePageChange = (page) => {
    const { startIndex: start, endIndex: end } = calculateIndex(page, startIndex, endIndex);
    setCurrentPage(page);
    setStartIndex(start);
    setEndIndex(end);
    if (partnerType === "Subcontractor")
      getPagedData(subcontractorPerformers, page, pageSize);
    else
      getPagedData(recruiterPerformers, page, pageSize);
  };

  const handlePageSizeChanged = ({ currentTarget }) => {
    const newSize = Number(currentTarget.value);
    setPageSize(newSize);
    setCurrentPage(1);
    setStartIndex(0);
    setEndIndex(5);
    if (partnerType === "Subcontractor")
      getPagedData(subcontractorPerformers, 1, newSize);
    else
      getPagedData(recruiterPerformers, 1, newSize);
  };

  const handleNextTask = () => {
    console.log("")
  }

  const handleViewSubcontractorForm = (type, item) => {
    if (viewFormType === type) {
      setViewFormType("");
      setUpdatedStateData(null)
    } else {
      if (item.partnerType === "Sub-Contractors") {
        setWfTask({ formId: config.formIds.subcontractor, ciid: 0 });
        dispatch(loadSubcontractorBprmForm(config.formIds.subcontractor))
      } else {
        setWfTask({ formId: config.formIds.recruiter, ciid: 0 });
        dispatch(loadRecruiterBprmForm(config.formIds.recruiter))
      }
      setViewFormType(type);
      setUpdatedStateData(item.contact1.performerData);
    }
  }

  const handleRemainder = async (id) => {
    dispatch(SendReminder(id));
  };

  useEffect(() => {
    const state = location?.state;
    var frmBody = new FormData();
    frmBody.append("name", "");
    frmBody.append("email", "");
    if (remiderStatus === "success") {
      getAlert("", "Reminder Sent Successfully", "success");
      if (state?.obj) {
        const currentObj = state.obj;
        if (currentObj?.partnerType === "Sub-Contractors") {
          frmBody.append("id", currentObj?.fuid);
          frmBody.append("type", "Sub-Contractors");
          dispatch(loadSubcontractorsByFilter(frmBody));
        }
        else {
          frmBody.append("id", currentObj?.fuid);
          frmBody.append("type", "Recruiter");
          dispatch(loadSubcontractorsByFilter(frmBody));
        }
      }
    }
    dispatch(reminderSent())
  }, [remiderStatus])

  const handleRemainderMessage = () => {
    setRemainderMsgShowHide(!remainderMsgShowHide);
  };

  const handleResetSelection = () => {
    setSelectedUserId(0);
    setSelectedObj(null);
  }

  const handlePermissionShowHide = () => {
    handleResetSelection()
    setSelectedKey("home");
  };

  const handlePermissionShowHide2 = () => {
    if (currentUser?.fuid) {
      if (partnerType === "Subcontractor") {
        dispatch(loadSubcontractorPerformers(currentUser.fuid, true));
      } else {
        dispatch(loadRecruiterPerformers(currentUser.fuid, true));
      }
    }
    setSelectedKey("home");
  };

  const handleAddUser = () => {
    handleResetSelection();
    setSelectedKey("addedituser");
  };

  const handleRefresh = () => {
    if (currentUser?.fuid) {
      if (partnerType === "Subcontractor") {
        dispatch(loadSubcontractorPerformers(currentUser.fuid, true));
      } else {
        dispatch(loadRecruiterPerformers(currentUser.fuid, true));
      }
    }
  };

  let item = "";
  if (currentUser) item = currentUser;
  const activeCount = getSourcePerformers().filter(p => p.status).length;

  return (
    <React.Fragment>
      <style>{`
        /* ── Animations ── */
        @keyframes searchSlideDown {
          from { opacity: 0; transform: translateY(-8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes shimmer {
          0%   { background-position: -600px 0; }
          100% { background-position:  600px 0; }
        }
        @keyframes loadingBar {
          0%   { width: 0%;   opacity: 1; }
          70%  { width: 85%;  opacity: 1; }
          100% { width: 100%; opacity: 0; }
        }
        @keyframes rowFadeIn {
          from { opacity: 0; transform: translateY(4px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes tabFadeIn {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes emptyFadeUp {
          from { opacity: 0; transform: translateY(18px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        /* ── Main Card ── */
        .wf-main-card {
          background: rgba(255, 255, 255, 0.97) !important;
          border: 1px solid rgba(226, 232, 240, 0.8) !important;
          box-shadow: 0 4px 24px -4px rgba(15, 23, 42, 0.06), 0 1px 4px -1px rgba(15, 23, 42, 0.04) !important;
          border-radius: 18px !important;
          transition: all 0.3s ease !important;
          overflow: hidden !important;
          position: relative !important;
          height: auto !important;
          min-height: 420px !important;
          display: flex !important;
          flex-direction: column !important;
          margin-bottom: 0 !important;
        }

        /* ── Card Header Section (Integrated Style) ── */
        .wf-header-section {
          display: flex; align-items: flex-start; justify-content: space-between;
          flex-wrap: wrap; gap: 18px; padding: 22px 24px 18px;
          background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
          border-bottom: 1px solid #f1f5f9;
        }
        .wf-header-left { display: flex; align-items: flex-start; gap: 14px; flex: 1; }
        .wf-icon-box {
          width: 44px; height: 44px; border-radius: 12px;
          background: linear-gradient(135deg, #0f766e 0%, #2563eb 100%);
          display: flex; align-items: center; justify-content: center;
          color: #ffffff; font-size: 18px; flex-shrink: 0;
          box-shadow: 0 8px 16px rgba(37, 99, 235, 0.2);
        }
        .wf-title-block { min-width: 0; }
        .wf-kicker {
          display: inline-flex; align-items: center; gap: 6px;
          margin: 0 0 5px; color: #2563eb; font-size: 11px;
          font-weight: 800; letter-spacing: 0.08em; text-transform: uppercase;
        }
        .wf-title { font-size: 18px; font-weight: 800; color: #0f172a; margin: 0; line-height: 1.2; }
        .wf-subtitle { font-size: 13px; color: #64748b; margin: 6px 0 0; }

        .wf-header-meta { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-top: 12px; }
        .wf-meta-pill {
          display: inline-flex; align-items: center; gap: 6px;
          padding: 4px 10px; border-radius: 99px; background: #ffffff;
          border: 1px solid #e2e8f0; color: #475569; font-size: 12px; font-weight: 700;
        }
        .wf-meta-pill i { color: #2563eb; font-size: 11px; }

        /* ── Table Toolbar ── */
        .wf-toolbar {
          display: flex; align-items: center; justify-content: space-between;
          padding: 12px 20px; background: #ffffff; border-bottom: 1px solid #f1f5f9;
        }


        /* ── Search Panel ── */
        .search-panel-collapse {
          background: linear-gradient(135deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,0.95) 100%) !important;
          border: 1px solid rgba(203,213,225,0.7) !important;
          border-radius: 16px !important;
          padding: 0 !important;
          box-shadow: 0 4px 24px -6px rgba(15,23,42,0.08), inset 0 1px 0 rgba(255,255,255,0.9) !important;
          animation: searchSlideDown 0.3s cubic-bezier(0.16,1,0.3,1) both;
          margin-top: 12px !important;
          margin-bottom: 8px !important;
          overflow: hidden !important;
        }
        .sp-header {
          display: flex; align-items: center; justify-content: space-between;
          padding: 14px 20px 12px;
          border-bottom: 1px solid rgba(226,232,240,0.8);
          background: linear-gradient(90deg, #f8fafc 0%, #ffffff 100%);
        }
        .sp-header-title {
          display: flex; align-items: center; gap: 8px;
          font-size: 13px; font-weight: 700; color: #1e293b; letter-spacing: 0.1px;
        }
        .sp-header-title i { color: #2563eb; font-size: 13px; }
        .sp-body { padding: 18px 20px 14px; }
        .sp-footer {
          display: flex; align-items: center; justify-content: flex-end; gap: 8px;
          padding: 12px 20px;
          border-top: 1px solid rgba(226,232,240,0.7);
          background: linear-gradient(90deg, #ffffff 0%, #f8fafc 100%);
        }
        .wf-control-label {
          font-size: 11px !important; font-weight: 700 !important; color: #64748b !important;
          text-transform: uppercase !important; letter-spacing: 0.7px !important;
          margin-bottom: 7px !important; display: flex !important; align-items: center !important; gap: 5px !important;
        }
        .wf-control-label i { color: #94a3b8; font-size: 11px; }
        .wf-input-wrap { position: relative; }
        .wf-input-icon {
          position: absolute; left: 12px; top: 50%; transform: translateY(-50%);
          color: #94a3b8; font-size: 13px; pointer-events: none; transition: color 0.2s ease; z-index: 1;
        }
        .wf-input-wrap:focus-within .wf-input-icon { color: #2563eb; }
        .wf-input {
          border-radius: 10px !important; border: 1.5px solid #e2e8f0 !important;
          padding: 9px 14px 9px 36px !important; font-size: 13.5px !important;
          color: #1e293b !important; background: #ffffff !important;
          transition: all 0.2s cubic-bezier(0.4,0,0.2,1) !important;
          height: auto !important; width: 100% !important;
        }

        /* ── Buttons ── */
        .btn-search-trigger {
          display: inline-flex !important; align-items: center !important; justify-content: center !important;
          gap: 8px !important; background: #ffffff !important; border: 1px solid #e2e8f0 !important;
          padding: 6px 14px !important; border-radius: 8px !important; font-size: 12.5px !important;
          font-weight: 600 !important; color: #475569 !important; cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4,0,0.2,1) !important;
          height: 38px !important;
        }
        .btn-search-trigger:hover {
          background: #f8fafc !important; color: #0f172a !important;
          border-color: #cbd5e1 !important; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05) !important;
        }
        .btn-action-search {
          display: inline-flex !important; align-items: center !important; gap: 8px !important;
          background: #ffffff !important; border: 1px solid #cbd5e1 !important;
          padding: 8px 16px !important; border-radius: 8px !important; font-size: 13px !important;
          font-weight: 600 !important; color: #475569 !important; cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4,0,0.2,1) !important; outline: none !important;
        }
        .btn-action-search.btn-primary-search {
          background: #2563eb !important; color: #ffffff !important; border-color: #2563eb !important;
        }
        .btn-action-search:disabled {
          background: #f1f5f9 !important;
          color: #94a3b8 !important;
          border-color: #cbd5e1 !important;
          cursor: not-allowed !important;
          transform: none !important;
          box-shadow: none !important;
          opacity: 0.75 !important;
        }
        .btn-action-search.btn-primary-search:disabled {
          background: #cbd5e1 !important;
          color: #94a3b8 !important;
          border-color: #cbd5e1 !important;
          cursor: not-allowed !important;
          transform: none !important;
          box-shadow: none !important;
          opacity: 0.85 !important;
        }
        .btn-action-search.btn-danger-search {
          background: rgba(239,68,68,0.06) !important; color: #dc2626 !important;
          border: 1px solid rgba(239,68,68,0.18) !important;
        }

        /* ── Tabs ── */
        .wf-tab-bar {
          display: flex; align-items: stretch; gap: 4px;
          border-bottom: 2px solid #f1f5f9; margin-bottom: 0;
          padding: 8px 4px 0; position: relative;
        }
        .wf-tab-btn {
          position: relative; display: inline-flex; align-items: center; gap: 7px;
          border: none; background: transparent; padding: 9px 16px 11px;
          font-size: 13.5px; font-weight: 600; color: #64748b;
          cursor: pointer; border-radius: 8px 8px 0 0;
          transition: color 0.2s ease, background 0.2s ease; outline: none; white-space: nowrap;
        }
        .wf-tab-btn i { font-size: 13px; transition: color 0.2s ease; }
        .wf-tab-btn:hover { color: #1e293b; background: rgba(37,99,235,0.04); }
        .wf-tab-btn:focus, .wf-tab-btn:focus-visible, .wf-tab-btn:active {
          outline: none !important; box-shadow: none !important; border-color: transparent !important;
        }
        .wf-tab-btn.active { color: #2563eb; font-weight: 700; }
        .wf-tab-btn.active i { color: #2563eb; }
        .wf-tab-btn::after {
          content: ""; position: absolute; bottom: -2px; left: 0; right: 0;
          height: 2px; background: #2563eb; border-radius: 2px 2px 0 0;
          transform: scaleX(0); transition: transform 0.25s cubic-bezier(0.4,0,0.2,1);
        }
        .wf-tab-btn.active::after { transform: scaleX(1); }
        .wf-tab-badge {
          display: inline-flex; align-items: center; justify-content: center;
          min-width: 20px; height: 20px; padding: 0 6px; border-radius: 999px;
          font-size: 11px; font-weight: 700; background: #f1f5f9; color: #64748b;
          border: 1px solid #e2e8f0; line-height: 1;
        }

        /* ── Selected User Context Card ── */
        .wf-assign-card {
          display: flex; align-items: center; justify-content: space-between;
          gap: 20px; padding: 18px 22px;
          background: linear-gradient(135deg, rgba(37,99,235,0.04) 0%, rgba(124,58,237,0.03) 100%);
          border: 1px solid rgba(37,99,235,0.12); border-radius: 14px;
          margin: 12px 0; flex-wrap: wrap;
          animation: tabFadeIn 0.3s ease both;
        }
        .wf-assign-info { display: flex; align-items: center; gap: 14px; }
        .wf-assign-avatar {
          width: 44px; height: 44px; border-radius: 12px;
          background: linear-gradient(135deg, #2563eb, #7c3aed);
          display: flex; align-items: center; justify-content: center;
          color: white; font-size: 16px; font-weight: 700; flex-shrink: 0;
        }

        /* ── Table ── */
        .wf-table {
          width: 100% !important;
          border-collapse: separate !important;
          border-spacing: 0 2px !important;
        }
        .wf-table-scroll {
          overflow: auto !important; scrollbar-width: thin; scrollbar-color: #94a3b8 #f1f5f9;
          border-radius: 12px;
        }
        .wf-table-scroll::-webkit-scrollbar { width: 8px; height: 8px; }
        .wf-table-scroll::-webkit-scrollbar-track { background: #f1f5f9; border-radius: 999px; }
        .wf-table-scroll::-webkit-scrollbar-thumb {
          background: linear-gradient(180deg, #cbd5e1 0%, #94a3b8 100%);
          border-radius: 999px; border: 2px solid #f1f5f9;
        }
        .wf-table-scroll::-webkit-scrollbar-thumb:hover {
          background: linear-gradient(180deg, #94a3b8 0%, #64748b 100%);
        }
        .wf-thead {
          background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%) !important;
          position: sticky !important; top: 0 !important; z-index: 2 !important;
        }
        .wf-thead th {
          font-size: 11.5px !important; font-weight: 700 !important; color: #475569 !important;
          text-transform: uppercase !important; letter-spacing: 0.6px !important;
          padding: 13px 16px !important; border-bottom: 2px solid #e2e8f0 !important;
          border-top: none !important; white-space: nowrap !important;
        }
        .wf-table-row {
          cursor: pointer !important;
          transition: background 0.15s ease !important;
          animation: rowFadeIn 0.25s ease both !important;
        }
        .wf-table-row:hover {
          background: linear-gradient(90deg, rgba(37,99,235,0.04) 0%, rgba(37,99,235,0.015) 100%) !important;
        }
        .wf-table-row.selected-row {
          background: linear-gradient(90deg, rgba(37,99,235,0.07) 0%, rgba(37,99,235,0.02) 100%) !important;
          box-shadow: inset 4px 0 0 0 #2563eb !important;
        }
        .wf-table td {
          padding: 13px 16px !important; font-size: 13.5px !important; color: #334155 !important;
          border-bottom: 1px solid #f1f5f9 !important; vertical-align: middle !important;
          transition: color 0.15s ease !important;
        }
        .wf-table-row.selected-row td {
          color: #1e3a8a !important; font-weight: 500 !important;
          border-bottom: 1px solid rgba(37,99,235,0.08) !important;
        }
        .wf-table tbody tr:last-child td { border-bottom: none !important; }
        .wf-id-cell {
          display: inline-flex; align-items: center; gap: 6px;
          min-width: 64px; padding: 4px 8px; border-radius: 999px;
          background: #f8fafc; border: 1px solid #e2e8f0;
          font-size: 12px; font-weight: 700; color: #64748b;
        }
        .wf-id-cell.is-selected {
          background: rgba(37,99,235,0.08); border-color: rgba(37,99,235,0.22); color: #2563eb;
        }
        .wf-name-cell { display: flex; align-items: center; gap: 10px; min-width: 190px; }
        .wf-name-avatar {
          width: 34px; height: 34px; border-radius: 10px;
          display: inline-flex; align-items: center; justify-content: center;
          background: linear-gradient(135deg, rgba(37,99,235,0.12), rgba(20,184,166,0.1));
          border: 1px solid rgba(37,99,235,0.16);
          color: #1d4ed8; font-size: 12px; font-weight: 800; flex-shrink: 0;
        }
        .wf-name-meta { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
        .wf-name-main { font-weight: 700; color: #1e293b; }
        .wf-name-title { font-size: 11.5px; color: #64748b; font-weight: 500; }
        .wf-data-line {
          display: inline-flex; align-items: center; gap: 7px;
          color: #475569; font-size: 12.8px; white-space: nowrap;
        }
        .wf-data-line i { color: #94a3b8; font-size: 12px; }
        .wf-email-line {
          max-width: 250px; overflow: hidden; text-overflow: ellipsis;
        }
        .wf-empty-value { color: #cbd5e1; font-size: 12px; font-weight: 600; }

        .wf-empty-state {
          display: flex; flex-direction: column; align-items: center; justify-content: center;
          padding: 40px 24px; text-align: center; gap: 12px;
          animation: tabFadeIn 0.3s ease both;
        }
        .wf-empty-icon {
          width: 52px; height: 52px; border-radius: 14px;
          display: flex; align-items: center; justify-content: center; font-size: 22px;
          background: linear-gradient(135deg, rgba(37,99,235,0.08) 0%, rgba(124,58,237,0.06) 100%);
          border: 1px solid rgba(37,99,235,0.12); color: #2563eb; margin-bottom: 4px;
        }
        .wf-empty-title { font-size: 15px; font-weight: 700; color: #1e293b; margin: 0; }
        .wf-empty-desc { font-size: 13px; color: #64748b; margin: 0 auto; line-height: 1.6; }

        /* ── Badges ── */
        .badge-capsule {
          display: inline-flex !important; align-items: center !important; justify-content: center !important;
          padding: 4px 10px !important; border-radius: 20px !important;
          font-size: 12px !important; font-weight: 600 !important; line-height: 1 !important;
        }
        .badge-system { background: #f1f5f9 !important; color: #475569 !important; border: 1px solid #cbd5e1 !important; }
        .badge-azure { background: rgba(37,99,235,0.08) !important; color: #1d4ed8 !important; border: 1px solid rgba(37,99,235,0.15) !important; }
        .badge-active { background: rgba(16,185,129,0.08) !important; color: #047857 !important; border: 1px solid rgba(16,185,129,0.15) !important; }
        .badge-inactive { background: rgba(239,68,68,0.08) !important; color: #b91c1c !important; border: 1px solid rgba(239,68,68,0.15) !important; }
        .badge-success-modern { background: rgba(16,185,129,0.08) !important; color: #047857 !important; border: 1px solid rgba(16,185,129,0.15) !important; }
        .badge-warning-modern { background: rgba(245,158,11,0.08) !important; color: #b45309 !important; border: 1px solid rgba(245,158,11,0.15) !important; }

      `}</style>

      <div className="col-md-12">
        <div className="card mb-4 shadow-none wf-main-card">
          {/* ── Premium Integrated Header ── */}
          <div className="wf-header-section">
            <div className="wf-header-left">
              <div className="wf-icon-box">
                <i className={partnerType === "Recruiter" ? "fa fa-user-circle-o" : "fa fa-building-o"} />
              </div>
              <div className="wf-title-block">
                <h2 className="wf-title">
                  <button
                    onClick={() => handleViewSubcontractorForm("Form", performerdata)}
                    className="btn p-0 btn-link text-uppercase font-weight-bold"
                    style={{ fontSize: '20px', color: '#0f172a', textAlign: 'left', verticalAlign: 'baseline' }}
                  >
                    {performerdata?.label || "Loading..."}
                  </button>
                </h2>
                <p className="wf-subtitle">
                  {partnerType} &bull; Joined <Moment format="MMM Do YYYY">{performerdata?.createdDate}</Moment>
                </p>

                <div className="wf-header-meta">
                  <span className="wf-meta-pill">
                    <i className="fa fa-id-badge" /> ID: {performerdata?.fuid}
                  </span>
                  {item?.contact1?.performeremail && (
                    <span className="wf-meta-pill">
                      <i className="fa fa-envelope-o" /> {item.contact1.performeremail}
                    </span>
                  )}
                  <span className="wf-meta-pill">
                    <i className="fa fa-certificate" /> Enrollment: {performerdata?.enrollmentStatus ? "Complete" : "Pending"}
                  </span>

                  {/* Applications Meta Pills */}
                  {performerdata?.applications?.map((app, idx) => (
                    <span key={`app-pill-${idx}`} className="wf-meta-pill" style={{ borderColor: app.appSubmitted ? '#10b981' : '#f59e0b' }}>
                      <i className="fa fa-file-text-o" style={{ color: app.appSubmitted ? '#10b981' : '#f59e0b' }} />
                      App {app.applicationId}: {app.appSubmitted ? "Done" : "Review"}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            <div className="wf-header-right" style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
              <button
                className="btn-search-trigger"
                onClick={handleAddUser}
              >
                <i className="fa fa-user-plus" aria-hidden="true" /> Add User
              </button>
              <button
                className="btn-search-trigger"
                data-toggle="collapse"
                data-target="#partnerSearchPanel"
              >
                <i className="fa fa-filter" aria-hidden="true" /> Filters
              </button>
              <button
                className="btn-search-trigger"
                onClick={handleRefresh}
                title="Reload users"
              >
                <i className="fa fa-refresh" aria-hidden="true" /> Refresh
              </button>
              <button
                onClick={() => navigate(-1)}
                className="btn-search-trigger"
              >
                <i className="fa fa-arrow-left" aria-hidden="true" /> Back
              </button>
            </div>

          </div>

          {/* ── Toolbar ── */}
          <div className="wf-toolbar">
            <div className="d-flex align-items-center" style={{ gap: '14px' }}>
              <PageSizeOptions pageSize={pageSize} onChange={handlePageSizeChanged} />
              <span className="wf-meta-pill">
                <i className="fa fa-check-circle" aria-hidden="true" />
                {activeCount} Active
              </span>
              <span className="wf-meta-pill">
                <i className="fa fa-users" aria-hidden="true" />
                {rowsCount} Total
              </span>
            </div>
            <div className="d-flex align-items-center" style={{ gap: '8px' }}>
            </div>
          </div>

          {/* ── Search Panel ── */}
          <div className="px-3">
            <div className="collapse" id="partnerSearchPanel">
              <div className="search-panel-collapse">
                <div className="sp-header">
                  <span className="sp-header-title">
                    <i className="fa fa-sliders" />
                    Filter Users
                  </span>
                </div>
                <div className="sp-body">
                  <div className="row">
                    <div className="col-md-2 form-group">
                      <label htmlFor="performerId" className="wf-control-label">
                        <i className="fa fa-hashtag" /> ID
                      </label>
                      <div className="wf-input-wrap">
                        <i className="fa fa-hashtag wf-input-icon" aria-hidden="true" />
                        <input
                          type="text"
                          id="performerId"
                          className="form-control wf-input"
                          placeholder="e.g. 42"
                          value={performerId}
                          onChange={({ currentTarget }) => setPerformerId(currentTarget.value)}
                          onKeyDown={e => e.key === "Enter" && handleFilter()}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-md-5 form-group mb-3">
                      <label htmlFor="performerName" className="wf-control-label">
                        <i className="fa fa-id-card" /> Name
                      </label>
                      <div className="wf-input-wrap">
                        <i className="fa fa-search wf-input-icon" aria-hidden="true" />
                        <input
                          type="text"
                          id="performerName"
                          className="form-control wf-input"
                          placeholder="Search user name..."
                          value={performerName}
                          onChange={({ currentTarget }) => setPerformerName(currentTarget.value)}
                          onKeyDown={e => e.key === "Enter" && handleFilter()}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-md-5 form-group mb-3">
                      <label htmlFor="mobile" className="wf-control-label">
                        <i className="fa fa-phone" /> Mobile No.
                      </label>
                      <div className="wf-input-wrap">
                        <i className="fa fa-phone wf-input-icon" aria-hidden="true" />
                        <input
                          type="text"
                          id="mobile"
                          className="form-control wf-input"
                          placeholder="Mobile number..."
                          value={formatPhoneNumber(mobile)}
                          onChange={({ currentTarget }) => setMobile(currentTarget.value.replace(/[^\d]/g, ""))}
                          onKeyDown={e => e.key === "Enter" && handleFilter()}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="sp-footer">
                  <button className="btn-action-search" onClick={handleFilterCancel}>
                    <i className="fa fa-refresh mr-2" aria-hidden="true"></i>Reset
                  </button>
                  <button
                    className="btn-action-search btn-primary-search"
                    onClick={handleFilter}
                    disabled={isFiltering || (!performerId.trim() && !performerName.trim() && !mobile.trim())}
                  >
                    {isFiltering ? (
                      <>
                        <i className="fa fa-circle-o-notch fa-spin" aria-hidden="true" /> Applying...
                      </>
                    ) : (
                      <>
                        <i className="fa fa-search mr-2" aria-hidden="true"></i>Apply Filters
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* ── Tabs & Content ── */}
          <div className="card-body px-3 pt-0 pb-3 wf-tabs-container">
            <div className="wf-tab-bar">
              <button
                className={`wf-tab-btn${selectedKey === "home" ? " active" : ""}`}
                onClick={() => setSelectedKey("home")}
              >
                <i className="fa fa-list-alt" />
                Users
                <span className="wf-tab-badge">{rowsCount}</span>
              </button>
              <button
                className={`wf-tab-btn${selectedKey === "addedituser" ? " active" : ""}`}
                onClick={() => setSelectedKey("addedituser")}
              >
                <i className={`fa ${selectedUserId > 0 ? "fa-pencil-square-o" : "fa-user-plus"}`} />
                {selectedUserId > 0 ? "Edit" : "Add"} User
              </button>
              <button
                className={`wf-tab-btn${selectedKey === "status" ? " active" : ""}`}
                onClick={() => setSelectedKey("status")}
              >
                <i className="fa fa-toggle-on" />
                Activate / Deactivate
              </button>
            </div>

            {selectedKey === "home" && (
              <div className="wf-tab-panel">
                {selectedUserId > 0 && selectedObj && (
                  <div className="wf-assign-card">
                    <div className="wf-assign-info">
                      <div className="wf-assign-avatar">
                        {(selectedObj.name || "?").charAt(0).toUpperCase()}
                      </div>
                      <div className="wf-assign-meta">
                        <strong style={{ display: 'block', fontSize: '14px' }}>{selectedObj.name} {selectedObj.lastName}</strong>
                        <span style={{ fontSize: '12px', color: '#64748b' }}>
                          <i className="fa fa-envelope" style={{ marginRight: 4 }} />
                          {selectedObj.email}
                          {selectedObj.title && <> &bull; {selectedObj.title}</>}
                          &nbsp;&bull;&nbsp;
                          <span className={`badge-capsule ${selectedObj.status ? "badge-active" : "badge-inactive"}`} style={{ padding: "2px 8px", fontSize: 11 }}>
                            {selectedObj.status ? "Active" : "Inactive"}
                          </span>
                        </span>
                      </div>
                    </div>
                    <div className="wf-assign-actions" style={{ display: 'flex', gap: '8px' }}>
                      <button className="btn-action-search btn-primary-search" onClick={() => handleTabSelect("addedituser")}>
                        <i className="fa fa-pencil-square-o" /> Edit
                      </button>
                      <button className="btn-action-search" onClick={() => handleTabSelect("status")}>
                        <i className="fa fa-toggle-on" /> Status
                      </button>
                      <button
                        className="btn-action-search btn-danger-search"
                        onClick={handleResetSelection}
                        title="Clear selection"
                        style={{ padding: "8px 12px" }}
                      >
                        <i className="fa fa-times" />
                      </button>
                    </div>
                  </div>
                )}

                <div className="table-responsive mt-2 wf-table-scroll">
                  <table className="table align-items-center table-flush wf-table">
                    <thead className="wf-thead">
                      <tr>
                        <th>
                          ID
                          {selectedUserId > 0 && (
                            <span
                              style={{ cursor: "pointer", marginLeft: 6 }}
                              onClick={handleResetSelection}
                              title="Reset Selection"
                            >
                              <i className="fa fa-refresh text-primary" aria-hidden="true" />
                            </span>
                          )}
                        </th>
                        <th>Date Added</th>
                        <th>Name &amp; Title</th>
                        <th>Email</th>
                        <th>Login Type</th>
                        <th>Azure Email</th>
                        <th>Contact No.</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {performers.length === 0 ? (
                        <tr>
                          <td colSpan={8} style={{ padding: 0 }}>
                            <div className="wf-empty-state">
                              <div className="wf-empty-icon">
                                <i className={dataType === "filter" ? "fa fa-search" : "fa fa-users"} aria-hidden="true" />
                              </div>
                              <p className="wf-empty-title">
                                {dataType === "filter" ? "No Matching Users" : "No Users Assigned"}
                              </p>
                              <p className="wf-empty-desc">
                                {dataType === "filter"
                                  ? "Try adjusting or resetting the filters to see users."
                                  : "There are no users assigned to this partner yet. Add a user to get started."}
                              </p>
                              {dataType === "filter" ? (
                                <button
                                  className="btn-action-search"
                                  onClick={handleFilterCancel}
                                  style={{ marginTop: 4 }}
                                >
                                  <i className="fa fa-refresh" aria-hidden="true" /> Reset Filters
                                </button>
                              ) : (
                                <button
                                  className="btn-action-search btn-primary-search"
                                  onClick={handleAddUser}
                                  style={{ marginTop: 4 }}
                                >
                                  <i className="fa fa-user-plus" /> Add First User
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ) : (
                        performers.map((performer, idx) => (
                          <tr
                            key={performer.id}
                            className={`wf-table-row${selectedUserId === performer.id ? " selected-row" : ""}`}
                            onClick={() => handleSelection(performer)}
                            style={{ animationDelay: `${idx * 0.04}s` }}
                            title={selectedUserId === performer.id ? `Click to deselect: ${performer.name}` : `Click to select: ${performer.name}`}
                          >
                            <td>
                              <span
                                className={`wf-id-cell${selectedUserId === performer.id ? " is-selected" : ""}`}
                              >
                                {selectedUserId === performer.id && (
                                  <i className="fa fa-check-circle text-primary" style={{ fontSize: "12px" }} />
                                )}
                                #{performer.id}
                              </span>
                            </td>
                            <td>
                              <span className="wf-data-line">
                                <i className="fa fa-calendar-o" aria-hidden="true" />
                                {performer.addedDateTime ? (
                                  <Moment format="MMM Do YYYY">{performer.addedDateTime}</Moment>
                                ) : (
                                  <span className="wf-empty-value">Not available</span>
                                )}
                              </span>
                            </td>
                            <td>
                              <div className="wf-name-cell">
                                <span className="wf-name-avatar">{getInitials(performer)}</span>
                                <div className="wf-name-meta">
                                  <span className="wf-name-main">{getDisplayName(performer)}</span>
                                  {performer.title ? (
                                    <span className="wf-name-title">{performer.title}</span>
                                  ) : (
                                    <span className="wf-empty-value">No title</span>
                                  )}
                                </div>
                              </div>
                            </td>
                            <td>
                              <span className="wf-data-line wf-email-line">
                                <i className="fa fa-envelope-o" aria-hidden="true" />
                                {performer.email || <span className="wf-empty-value">No email</span>}
                              </span>
                            </td>
                            <td>
                              {performer.loginType === 1 ? (
                                <span className="badge-capsule badge-azure">
                                  <i className="fa fa-windows" style={{ marginRight: 4 }} aria-hidden="true" />
                                  Azure AD
                                </span>
                              ) : (
                                <span className="badge-capsule badge-system">
                                  <i className="fa fa-desktop" style={{ marginRight: 4 }} aria-hidden="true" />
                                  System
                                </span>
                              )}
                            </td>
                            <td>
                              {performer.azureEmailId ? (
                                <span className="wf-data-line wf-email-line">
                                  <i className="fa fa-at" aria-hidden="true" />
                                  {performer.azureEmailId}
                                </span>
                              ) : (
                                <span className="wf-empty-value">Not linked</span>
                              )}
                            </td>
                            <td>
                              {performer.contact ? (
                                <span className="wf-data-line">
                                  <i className="fa fa-phone" aria-hidden="true" />
                                  {getFormatedNumber(performer.contact)}
                                </span>
                              ) : (
                                <span className="wf-empty-value">No contact</span>
                              )}
                            </td>
                            <td>
                              {performer.status ? (
                                <span className="badge-capsule badge-active">
                                  <i className="fa fa-check" style={{ marginRight: 4 }} aria-hidden="true" />
                                  Active
                                </span>
                              ) : (
                                <span className="badge-capsule badge-inactive">
                                  <i className="fa fa-times" style={{ marginRight: 4 }} aria-hidden="true" />
                                  Inactive
                                </span>
                              )}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="mt-3">
                  <Pagination
                    currentPage={currentPage}
                    pageSize={pageSize}
                    itemsCount={rowsCount}
                    onPageChange={handlePageChange}
                    startIndex={startIndex}
                    endIndex={endIndex}
                  />
                </div>
              </div>
            )}

            {selectedKey === "addedituser" && (
              <div className="wf-tab-panel pt-3">
                <AddPartnerPerformer
                  selectedObj={selectedObj}
                  currentUser={currentUser}
                  handleFormSubmit={handleFormSubmit}
                  handlePermissionShowHide={handlePermissionShowHide}
                  partnerType={partnerType}
                />
              </div>
            )}

            {selectedKey === "status" && (
              <div className="wf-tab-panel pt-3">
                {selectedUserId > 0 ? (
                  <ActiveDeactiveHistory
                    selectedObj={selectedObj}
                    type="performer"
                    typeName="user"
                    actionType={actionType}
                    handlePermissionShowHide2={handlePermissionShowHide2}
                  />
                ) : (
                  <div className="wf-empty-state">
                    <div className="wf-empty-icon">
                      <i className="fa fa-toggle-on" aria-hidden="true" />
                    </div>
                    <p className="wf-empty-title">No User Selected</p>
                    <p className="wf-empty-desc">
                      Select a user from the <strong>Users</strong> tab to activate, deactivate, or review their status history.
                    </p>
                    <button
                      className="btn-action-search"
                      onClick={() => handleTabSelect("home")}
                      style={{ marginTop: 4 }}
                    >
                      <i className="fa fa-arrow-left" /> Back to Users
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {wfForm && viewFormType && (
          <div className="p-0 border-0 mt-3 animation-fade-in" style={{ animation: 'tabFadeIn 0.4s ease both' }}>
            <div className="pop-container" style={{ border: '1px solid #e2e8f0', borderRadius: '16px', overflow: 'hidden', background: 'white', boxShadow: '0 10px 30px rgba(0,0,0,0.05)' }}>
              <div className="pop-header" style={{ padding: '16px 24px', borderBottom: '1px solid #f1f5f9', background: '#f8fafc', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h4 className="m-0 font-weight-bold text-primary">
                  <i className="fa fa-file-text-o mr-2" />
                  Partner Form Details
                </h4>
                <button
                  className="pop-action-btn back"
                  onClick={() => handleViewSubcontractorForm(`${viewFormType}`, null)}
                  style={{ background: 'white', border: '1px solid #cbd5e1', padding: '6px 16px', borderRadius: '8px', cursor: 'pointer' }}
                >
                  <i className="fa fa-times mr-2" />Close
                </button>
              </div>
              <div className="p-4">
                <WorkflowElement
                  wfTask={wfTask}
                  wfForm={wfForm}
                  handleNextTask={handleNextTask}
                  viewType={true}
                  appSummary={false}
                  codeVerified={true}
                  wfTaskType={"form"}
                  updatedStateData={updatedStateData}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}
